export const defaultcolumns = [
  {
    internVisible: true,
    dataField: 'field_001',
    caption: 'event.list.id',
    name: 'field_001',
    dataType: 'number',
    width: 150,
    visible: false,
    alignment: 'right',
    allowEditing: false,
    allowHeaderFiltering: false,
    allowSorting: false,
    allowFiltering: false
  },
  {
    dataField: 'cRMAddress.field_001',
    name: 'cRMAddress.field_001',
    caption: 'event.detail.addressId',
    dataType: 'number',
    width: 100,
    visible: true,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowSorting: true,
    allowFiltering: false
  },
  {
    dataField: 'bestelldatum',
    caption: 'event.detail.orderdate',
    name: 'bestelldatum',
    dataType: 'date',
    width: 150,
    visible: false,
    format: 'dd.MM.yyyy',
    alignment: 'right',
    allowEditing: false,
    allowHeaderFiltering: false,
    allowSorting: true,
    allowFiltering: false
  },
  {
    dataField: 'cRMAddress.company',
    caption: 'event.detail.company',
    name: 'cRMAddress.company',
    dataType: 'string',
    width: 300,
    visible: true,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowSorting: true,
    allowFiltering: true
  },
  {
    dataField: 'casequality',
    name: 'casequality',
    caption: 'event.detail.casequality',
    dataType: 'number',
    width: 80,
    visible: true,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowSorting: true,
    allowFiltering: false,
    lookup: {
      dataSource: 'casequalityTypes',
      displayExpr: 'casequality',
      valueExpr: 'field_001',
      allowClearing: true
    }
  },
  {
    dataField: 'eventSignupFunkionIDId',
    name: 'eventSignupFunkionIDId',
    caption: 'event.detail.funktionEN',
    dataType: 'number',
    width: 150,
    visible: false,
    allowEditing: true,
    allowHeaderFiltering: true,
    allowSorting: true,
    allowFiltering: true,
    lookup: {
      dataSource: 'eventSignupFunctions',
      displayExpr: 'funktionEN',
      valueExpr: 'field_001',
      allowClearing: true
    }
  },
  {
    dataField: 'eventSignupAffirmIDId',
    name: 'eventSignupAffirmIDId',
    caption: 'event.detail.affirmationEN',
    dataType: 'number',
    width: 150,
    visible: true,
    allowEditing: true,
    allowHeaderFiltering: true,
    allowSorting: true,
    allowFiltering: true,
    lookup: {
      dataSource: 'affirmationTypes',
      displayExpr: 'affirmationEN',
      valueExpr: 'field_001',
      allowClearing: true
    }
  },
  {
    dataField: 'cRMAddress.profiles[0].oneLiner_en',
    name: 'cRMAddress.profiles[0].oneLiner_en',
    caption: 'event.detail.oneLinerEn',
    dataType: 'string',
    width: 400,
    visible: true,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false,
    isProfile: true
  },
  {
    dataField: 'cRMAddress.profiles[0].description_open_en',
    name: 'cRMAddress.profiles[0].description_open_en',
    caption: 'event.detail.descriptionEN',
    dataType: 'string',
    width: 600,
    visible: false,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false,
    isProfile: true
  },
  {
    dataField: 'cRMAddress.streetB',
    name: 'cRMAddress.streetB',
    caption: 'event.detail.streetB',
    dataType: 'string',
    width: 150,
    visible: false,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowSorting: true
  },
  {
    dataField: 'cRMAddress.zipB',
    name: 'cRMAddress.zipB',
    caption: 'event.detail.zipB',
    dataType: 'string',
    width: 80,
    visible: false,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowSorting: true
  },
  {
    dataField: 'cRMAddress.cityB',
    name: 'cRMAddress.cityB',
    caption: 'event.detail.cityB',
    dataType: 'string',
    width: 150,
    visible: true,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowSorting: true
  },
  {
    dataField: 'cRMAddress.countryBId',
    name: 'cRMAddress.countryBId',
    caption: 'event.detail.countryB',
    dataType: 'string',
    width: 150,
    visible: true,
    allowEditing: true,
    allowHeaderFiltering: true,
    allowFiltering: true,
    allowSorting: true,
    lookup: {
      dataSource: 'countryTypes',
      displayExpr: 'land',
      valueExpr: 'field_001',
      allowClearing: true
    }
  },
  {
    dataField: 'cRMAddress.incorporationDate',
    name: 'cRMAddress.incorporationDate',
    caption: 'event.detail.incorporationDate',
    visible: true,
    alignment: 'right',
    dataType: 'date',
    format: 'dd.MM.yyyy',
    width: 100,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowSorting: true
  },
  {
    dataField: 'cRMAddress.cRMUniFaculty.universityIDId',
    name: 'cRMAddress.cRMUniFaculty.universityIDId',
    caption: 'event.detail.university',
    dataType: 'number',
    width: 200,
    visible: false,
    allowEditing: true,
    allowHeaderFiltering: true,
    allowFiltering: true,
    allowSorting: true,
    lookup: {
      dataSource: 'universityTypes',
      displayExpr: 'university',
      valueExpr: 'field_001',
      allowClearing: true
    }
  },
  {
    dataField: 'cRMAddress.universityFacultyIDId',
    name: 'cRMAddress.universityFacultyIDId',
    caption: 'event.detail.faculty',
    dataType: 'number',
    visible: false,
    width: 200,
    allowEditing: true,
    allowHeaderFiltering: true,
    allowFiltering: true,
    allowSorting: true,
    lookup: {
      dataSource: 'getFilteredFaculties',
      displayExpr: 'departementFaculty',
      valueExpr: 'field_001'
    }
  },
  {
    dataField: 'cRMAddress.firstname',
    name: 'cRMAddress.firstname',
    caption: 'event.detail.firstname',
    visible: true,
    width: 150,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowSorting: true
  },
  {
    dataField: 'cRMAddress.lastname',
    name: 'cRMAddress.lastname',
    caption: 'event.detail.lastname',
    visible: true,
    width: 150,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowSorting: true
  },
  {
    dataField: 'cRMAddress.mobileB',
    name: 'cRMAddress.mobileB',
    caption: 'event.detail.mobile',
    visible: false,
    width: 150,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowSorting: true
  },
  {
    dataField: 'cRMAddress.phoneB',
    name: 'cRMAddress.phoneB',
    caption: 'event.detail.phoneB',
    visible: false,
    width: 150,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowSorting: true
  },
  {
    dataField: 'cRMAddress.emailB1',
    name: 'cRMAddress.emailB1',
    caption: 'event.detail.email',
    visible: true,
    width: 150,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowSorting: true,
    validationRules: [
      {
        type: 'pattern',
        message: 'Enter a valid Email',
          pattern: '^[^@]+@[^@]+\.[^@]+$' /* eslint-disable-line */
      }
    ]
  },
  {
    dataField: 'cRMAddress.emailB2',
    name: 'cRMAddress.emailB2',
    caption: 'event.detail.emailB2',
    visible: false,
    width: 150,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowSorting: true,
    validationRules: [
      {
        type: 'pattern',
        message: 'Enter a valid Email',
          pattern: '^[^@]+@[^@]+\.[^@]+$' /* eslint-disable-line */
      }
    ]
  },
  {
    dataField: 'cRMAddress.facebookB',
    name: 'cRMAddress.facebookB',
    caption: 'event.detail.facebookB',
    visible: false,
    width: 150,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowSorting: true
  },
  {
    dataField: 'cRMAddress.linkedInB',
    name: 'cRMAddress.linkedInB',
    caption: 'event.detail.linkedInB',
    visible: false,
    width: 150,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowSorting: true
  },
  {
    dataField: 'cRMAddress.twitterB',
    name: 'cRMAddress.twitterB',
    caption: 'event.detail.twitterB',
    visible: false,
    width: 150,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowSorting: true
  },
  {
    dataField: 'cRMAddress.instagramB',
    name: 'cRMAddress.instagramB',
    caption: 'event.detail.instagramB',
    visible: false,
    width: 150,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowSorting: true,
    validationRules: [
      {
        type: 'pattern',
        message: 'Enter a valid URL',
        pattern: '((http|https)://)|([A-Za-z]{2,}[.][A-Za-z]{2,})'
      }
    ]
  },
  {
    dataField: 'cRMAddress.similarwebB',
    name: 'cRMAddress.similarwebB',
    caption: 'event.detail.similarwebB',
    visible: false,
    width: 150,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowSorting: true,
    validationRules: [
      {
        type: 'pattern',
        message: 'Enter a valid URL',
        pattern: '((http|https)://)|([A-Za-z]{2,}[.][A-Za-z]{2,})'
      }
    ]
  },
  {
    dataField: 'cRMAddress.alexaB',
    name: 'cRMAddress.alexaB',
    caption: 'event.detail.alexaB',
    visible: false,
    width: 150,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowSorting: true,
    validationRules: [
      {
        type: 'pattern',
        message: 'Enter a valid URL',
        pattern: '((http|https)://)|([A-Za-z]{2,}[.][A-Za-z]{2,})'
      }
    ]
  },
  {
    dataField: 'salutationId',
    name: 'cRMAddress.salutationId',
    caption: 'event.detail.salutationId',
    width: 150,
    visible: true,
    dataType: 'number',
    allowEditing: true,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: true,
    withoutQueryField: true,
    calculateCellValue: 'getSalutationId',
    lookup: {
      dataSource: 'salutationTypes',
      displayExpr: 'getDisplayExpr',
      displayExprFunction: true,
      valueExpr: 'ansprechzeile_id'
    }
  },
  {
    dataField: 'cRMAddress.permalink',
    name: 'cRMAddress.permalink',
    caption: 'event.detail.startuplink',
    allowEditing: false,
    width: 180,
    visible: true,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false,
    cellTemplate: 'permalink-template'
  },
  {
    dataField: 'cRMAddress.internetB',
    name: 'cRMAddress.internetB',
    caption: 'event.detail.internet',
    width: 150,
    visible: true,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowSorting: true,
    validationRules: [
      {
        type: 'pattern',
        message: 'Enter a valid URL',
        pattern: '((http|https)://)|([A-Za-z]{2,}[.][A-Za-z]{2,})'
      }
    ]
  },
  {
    dataField: 'cRMAddress.startupPhaseId',
    name: 'cRMAddress.startupPhaseId',
    caption: 'event.detail.startupPhase',
    width: 150,
    visible: true,
    allowEditing: true,
    allowHeaderFiltering: true,
    allowFiltering: true,
    allowSorting: true,
    lookup: {
      dataSource: 'startupPhaseTypes',
      displayExpr: 'startupphase',
      valueExpr: 'field_001',
      allowClearing: true
    }
  },
  {
    caption: 'event.detail.evaluations',
    dataField: 'vLABEvaluations.cRMMitarbeiter.vorname',
    cellTemplate: 'evaluation-template',
    calculateCellValue: 'calculateEvaluations',
    calculateSortValue: 'returnSortEvaluations',
    width: 300,
    allowEditing: false,
    allowSorting: false,
    allowHeaderFiltering: false,
    allowFiltering: false
  },
  {
    adminOnly: true,
    dataField: 'totalFunding',
    caption: 'event.detail.totalFunding',
    calculateCellValue: 'calcTotal',
    format: { style: 'currency', currency: 'CHF', useGrouping: true, minimumSignificantDigits: 3 },
    allowFiltering: false,
    allowSorting: false,
    allowEditing: false,
    width: 150,
    allowHeaderFiltering: false,
    withoutQueryField: true
  },
  {
    adminOnly: true,
    dataField: 'cRMAddress.profiles[0].cRMFundingProfileV2s.investmentsTypeId',
    caption: 'event.detail.fundraisingGoalLatestFunding',
    calculateCellValue: 'fundraisingGoal',
    format: { style: 'currency', currency: 'CHF', useGrouping: true, minimumSignificantDigits: 3 },
    allowFiltering: false,
    allowSorting: false,
    allowEditing: false,
    width: 150,
    visible: false,
    allowHeaderFiltering: false,
    isProfile: true
  },
  {
    adminOnly: true,
    dataField: 'closingDateLatestFunding',
    caption: 'event.detail.closingDateLatestFunding',
    calculateCellValue: 'latestClosingDate',
    allowFiltering: false,
    allowSorting: false,
    allowEditing: false,
    alignment: 'right',
    dataType: 'date',
    format: 'dd.MM.yyyy',
    width: 100,
    visible: false,
    allowHeaderFiltering: false,
    withoutQueryField: true
  },
  {
    adminOnly: true,
    dataField: 'stageLatestFunding',
    caption: 'event.detail.stageLatestFunding',
    calculateCellValue: 'latestStage',
    allowFiltering: false,
    allowSorting: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    width: 100,
    visible: false,
    lookup: {
      dataSource: 'investmentStages',
      displayExpr: 'investmentsStage',
      valueExpr: 'field_001'
    },
    withoutQueryField: true
  },
  {
    dataField: 'cRMAddress.technologyId',
    caption: 'event.detail.technology',
    visible: false,
    width: 200,
    allowFiltering: true,
    allowSorting: true,
    allowEditing: true,
    allowHeaderFiltering: true,
    lookup: {
      dataSource: 'brancheTypes',
      displayExpr: 'brancheEn',
      valueExpr: 'field_001',
      allowClearing: true
    }
  },
  {
    caption: 'event.detail.sectors',
    dataField: 'cRMAddress.profiles[0].pROFILProfilJOINCategories.pROFILCategory.kategorieDE',
    cellTemplate: 'sectors-template',
    calculateCellValue: 'calculateSectors',
    width: 500,
    allowEditing: false,
    visible: false,
    allowHeaderFiltering: false,
    allowSorting: false,
    allowFiltering: false,
    isProfile: true
  },
  {
    dataField: 'cRMAddress.unispinoffId',
    caption: 'event.detail.unispinoff',
    visible: false,
    width: 200,
    allowFiltering: true,
    allowSorting: true,
    allowEditing: true,
    allowHeaderFiltering: true,
    lookup: {
      dataSource: 'universityTypes',
      displayExpr: 'university',
      valueExpr: 'field_001',
      allowClearing: true
    }
  },
  {
    dataField: 'vENTURELAB_internal_comment',
    caption: 'event.detail.venturelabInternalComment',
    width: 500,
    allowHeaderFiltering: false,
    visible: true,
    allowFiltering: true,
    allowSorting: false,
    allowEditing: true
  },
  {
    dataField: 'supportVK',
    calculateCellValue: 'getDisplayExprVK',
    caption: 'event.detail.ventureKick',
    allowEditing: false,
    width: 70,
    alignment: 'center',
    visible: false,
    allowSorting: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    withoutQueryField: true
  },
  {
    dataField: 'supportVL',
    calculateCellValue: 'getDisplayExprVL',
    caption: 'event.detail.ventureLeaders',
    allowEditing: false,
    width: 70,
    alignment: 'center',
    visible: false,
    allowSorting: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    withoutQueryField: true
  },
  {
    dataField: 'supportT100',
    calculateCellValue: 'getDisplayExprT100',
    caption: 'event.detail.Top100',
    allowEditing: false,
    width: 70,
    alignment: 'center',
    visible: false,
    allowSorting: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    withoutQueryField: true
  },
  {
    dataField: 'supportIS',
    calculateCellValue: 'getDisplayExprIS',
    caption: 'event.detail.InnoSuisse',
    allowEditing: false,
    width: 70,
    alignment: 'center',
    visible: false,
    allowSorting: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    withoutQueryField: true
  },
  {
    dataField: 'cRMAddress.priovlabId',
    caption: 'event.detail.priovlabId',
    visible: false,
    width: 100,
    allowSorting: true,
    allowHeaderFiltering: true,
    allowFiltering: true,
    allowEditing: true,
    lookup: {
      dataSource: 'priovlabTypes',
      displayExpr: 'status',
      valueExpr: 'field_001',
      allowClearing: true
    }
  },
  {
    dataField: 'cRMAddress.prioXMasId',
    caption: 'event.detail.prioXMasId',
    visible: false,
    width: 100,
    allowSorting: true,
    allowHeaderFiltering: true,
    allowFiltering: true,
    allowEditing: true,
    lookup: {
      dataSource: 'priovlabxmasTypes',
      displayExpr: 'statusxmas',
      valueExpr: 'field_001',
      allowClearing: true
    }
  },
  {
    dataField: 'cRMAddress.vKCaseStatus',
    caption: 'event.detail.vKCaseStatus',
    visible: false,
    width: 150,
    allowSorting: true,
    allowHeaderFiltering: true,
    allowFiltering: true,
    allowEditing: true,
    lookup: {
      dataSource: 'vkCaseStatusTypes',
      displayExpr: 'casestatus',
      valueExpr: 'field_001',
      allowClearing: true
    }
  },
  {
    dataField: 'cRMAddress.vKacademiclinkId',
    caption: 'event.detail.vKacademiclink',
    visible: false,
    width: 200,
    allowSorting: true,
    allowHeaderFiltering: true,
    allowFiltering: true,
    allowEditing: true,
    lookup: {
      dataSource: 'universityTypes',
      displayExpr: 'university',
      valueExpr: 'field_001',
      allowClearing: true
    }
  },
  {
    dataField: 'cRMAddress.tradeRegisterNr',
    caption: 'event.detail.tradeRegisterNr',
    visible: false,
    width: 200,
    allowSorting: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowEditing: true
  },
  {
    dataField: 'cRMAddress.legalFormId',
    caption: 'event.detail.legalFormId',
    visible: false,
    width: 150,
    allowSorting: true,
    allowHeaderFiltering: true,
    allowFiltering: true,
    allowEditing: true,
    lookup: {
      dataSource: 'rechtsformTypes',
      displayExpr: 'rechtsform',
      valueExpr: 'field_001',
      allowClearing: true
    }
  },
  {
    dataField: 'cRMAddress.streetP',
    caption: 'event.detail.streetP',
    visible: false,
    width: 150,
    allowSorting: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowEditing: true
  },
  {
    dataField: 'cRMAddress.zipP',
    caption: 'event.detail.zipP',
    visible: false,
    width: 80,
    allowSorting: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowEditing: true
  },
  {
    dataField: 'cRMAddress.cityP',
    caption: 'event.detail.cityP',
    visible: false,
    width: 150,
    allowHeaderFiltering: false,
    allowSorting: true,
    allowFiltering: true,
    allowEditing: true
  },
  {
    dataField: 'cRMAddress.countryPId',
    caption: 'event.detail.countryP',
    visible: false,
    width: 200,
    allowSorting: true,
    allowHeaderFiltering: true,
    allowFiltering: true,
    allowEditing: true,
    lookup: {
      dataSource: 'countryTypes',
      displayExpr: 'land',
      valueExpr: 'field_001'
    }
  },
  {
    dataField: 'cRMAddress.mobileP',
    caption: 'event.detail.mobileP',
    visible: false,
    width: 150,
    allowSorting: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowEditing: true
  },
  {
    dataField: 'cRMAddress.phoneP',
    caption: 'event.detail.phoneP',
    visible: false,
    width: 150,
    allowSorting: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowEditing: true
  },
  {
    dataField: 'cRMAddress.emailP1',
    caption: 'event.detail.emailP1',
    visible: false,
    width: 150,
    allowSorting: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowEditing: true,
    validationRules: [
      {
        type: 'pattern',
        message: 'Enter a valid Email',
          pattern: '^[^@]+@[^@]+\.[^@]+$' /* eslint-disable-line */
      }
    ]
  },
  {
    dataField: 'cRMAddress.emailP2',
    caption: 'event.detail.emailP2',
    visible: false,
    width: 150,
    allowSorting: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowEditing: true,
    validationRules: [
      {
        type: 'pattern',
        message: 'Enter a valid Email',
        pattern: '^[^@]+@[^@]+\.[^@]+$' /* eslint-disable-line */
      }
    ]
  },
  {
    dataField: 'cRMAddress.facebookP',
    caption: 'event.detail.facebookP',
    visible: false,
    width: 150,
    allowSorting: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowEditing: true
  },
  {
    dataField: 'cRMAddress.linkedInP',
    caption: 'event.detail.linkedInP',
    visible: false,
    width: 150,
    allowSorting: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowEditing: true
  },
  {
    dataField: 'cRMAddress.twitterP',
    caption: 'event.detail.twitterP',
    visible: false,
    width: 150,
    allowSorting: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowEditing: true,
    validationRules: [
      {
        type: 'pattern',
        message: 'Enter a valid URL',
        pattern: '((http|https)://)|([A-Za-z]{2,}[.][A-Za-z]{2,})'
      }
    ]
  },
  {
    dataField: 'birthday',
    name: 'cRMAddress.birthday',
    caption: 'event.detail.birthday',
    calculateCellValue: 'getBirthday',
    dataType: 'date',
    format: 'dd.MM.yyyy',
    visible: false,
    alignment: 'right',
    width: 100,
    allowSorting: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowEditing: false,
    withoutQueryField: true
  },
  {
    dataField: 'cRMAddress.languageId',
    caption: 'event.detail.languageId',
    visible: false,
    width: 100,
    allowSorting: true,
    allowHeaderFiltering: true,
    allowFiltering: true,
    allowEditing: true,
    lookup: {
      dataSource: 'languagesTypes',
      displayExpr: 'spracheEN',
      valueExpr: 'field_001'
    }
  },
  {
    dataField: 'cRMAddress.educationId',
    caption: 'event.detail.educationId',
    visible: false,
    width: 150,
    allowSorting: true,
    allowHeaderFiltering: true,
    allowFiltering: true,
    allowEditing: true,
    lookup: {
      dataSource: 'educationTypes',
      displayExpr: 'education',
      valueExpr: 'field_001',
      allowClearing: true
    }
  },
  {
    dataField: 'cRMAddress.position',
    caption: 'event.detail.position',
    visible: false,
    width: 180,
    allowSorting: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowEditing: true
  },
  {
    dataField: 'cRMAddress.kantonId',
    caption: 'event.detail.kantonId',
    visible: false,
    width: 150,
    allowSorting: true,
    allowHeaderFiltering: true,
    allowFiltering: true,
    allowEditing: true,
    lookup: {
      dataSource: 'cantonTypes',
      displayExpr: 'kantonEN',
      valueExpr: 'field_001',
      allowClearing: true
    }
  },
  {
    dataField: 'cRMAddress.sUTkrTradeRegUID',
    caption: 'event.detail.sutkruid',
    visible: false,
    width: 100,
    allowSorting: true,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowEditing: true
  },
  {
    adminOnly: true,
    dataField: 'cRMAddress.profiles[0].pEOPLEFemaleFounders',
    caption: 'event.detail.peoplefemalefounders',
    visible: false,
    width: 150,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false,
    allowEditing: true,
    isProfile: true
  },
  {
    adminOnly: true,
    dataField: 'cRMAddress.profiles[0].pEOPLEMaleFounders',
    caption: 'event.detail.peoplemalefounders',
    visible: false,
    width: 150,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false,
    allowEditing: true,
    isProfile: true
  },
  {
    adminOnly: true,
    dataField: 'cRMAddress.profiles[0].peopleEPFLFac',
    caption: 'event.detail.peopleEPFLFac',
    visible: false,
    width: 150,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false,
    allowEditing: true,
    isProfile: true
  },
  {
    adminOnly: true,
    dataField: 'cRMAddress.profiles[0].peopleEPFLLab',
    caption: 'event.detail.peopleEPFLLab',
    visible: false,
    width: 150,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false,
    allowEditing: true,
    isProfile: true
  },
  {
    adminOnly: true,
    dataField: 'cRMAddress.profiles[0].peopleEPFLProf',
    caption: 'event.detail.peopleEPFLProf',
    visible: false,
    width: 150,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false,
    allowEditing: true,
    isProfile: true
  },
  {
    adminOnly: true,
    dataField: 'cRMAddress.profiles[0].totalEmployee',
    caption: 'event.detail.totalEmployee',
    visible: false,
    width: 150,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false,
    allowEditing: false,
    isProfile: true
  },
  {
    adminOnly: true,
    dataField: 'cRMAddress.profiles[0].changeDate',
    caption: 'event.detail.changeDate',
    dataType: 'date',
    format: 'dd.MM.yyyy',
    alignment: 'right',
    visible: false,
    allowEditing: false,
    width: 150,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false,
    isProfile: true
  },
  {
    adminOnly: true,
    dataField: 'cRMAddress.profiles[0].turnOver',
    caption: 'event.detail.turnover',
    visible: false,
    allowEditing: false,
    width: 150,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false,
    isProfile: true
  },
  {
    adminOnly: true,
    dataField: 'cRMAddress.profiles[0].ownedCopyrights',
    caption: 'event.detail.ownedCopyrights',
    visible: false,
    allowEditing: false,
    width: 150,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false,
    isProfile: true
  },
  {
    adminOnly: true,
    dataField: 'cRMAddress.profiles[0].ownedTrademarks',
    caption: 'event.detail.ownedTrademarks',
    visible: false,
    allowEditing: false,
    width: 150,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false,
    isProfile: true
  },
  {
    adminOnly: true,
    dataField: 'cRMAddress.profiles[0].pendingPatents',
    caption: 'event.detail.pendingPatents',
    visible: false,
    allowEditing: false,
    width: 150,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false,
    isProfile: true
  },
  {
    adminOnly: true,
    dataField: 'cRMAddress.profiles[0].grantedPatents',
    caption: 'event.detail.grantedPatents',
    visible: false,
    allowEditing: false,
    width: 150,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false,
    isProfile: true
  },
  {
    adminOnly: true,
    caption: 'event.detail.reportingGroups',
    dataField: 'cRMAddress.profiles[0].pROFILProfilJOINReportingGroups.pROFILReportingGroup.reportingGroups',
    cellTemplate: 'reporting-template',
    calculateCellValue: 'calculateReportinggroups',
    width: 300,
    allowEditing: false,
    visible: false,
    allowHeaderFiltering: false,
    allowSorting: false,
    allowFiltering: false,
    isProfile: true
  },
  {
    dataField: 'unicSession',
    cellTemplate: 'pdflink-template',
    caption: 'event.detail.pdflink',
    allowEditing: false,
    width: 180,
    visible: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    dataField: 'anmerkung',
    caption: 'event.detail.anmerkung',
    name: 'anmerkung',
    dataType: 'string',
    width: 400,
    visible: false,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowSorting: false,
    allowFiltering: true
  },
  {
    dataField: 'crmEvent.course_no',
    name: 'crmEvent.course_no',
    caption: 'event.detail.eventCourseNo',
    calculateCellValue: 'calcEventCourseCohort',
    width: 300,
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    dataField: 'ageGroup',
    name: 'cRMAddress.ageGroup',
    caption: 'event.detail.ageGroup',
    calculateCellValue: 'calculateAgeGroup',
    visible: false,
    width: 100,
    allowSorting: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowEditing: false,
    withoutQueryField: true
  },
  {
    dataField: 'iSstartupStageIDIS2025',
    name: 'iSstartupStageIDIS2025',
    caption: 'event.detail.startupStage',
    calculateCellValue: 'calcIsStartupStage2025',
    dataType: 'number',
    width: 150,
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowSorting: false,
    allowFiltering: false,
    lookup: {
      dataSource: 'eventStartupStages',
      displayExpr: 'startupstage',
      valueExpr: 'field_001',
      allowClearing: true
    }
  },
  {
    dataField: 'kurzbeschrieb',
    caption: 'event.detail.kurzbeschrieb',
    name: 'kurzbeschrieb',
    dataType: 'string',
    width: 300,
    visible: false,
    allowEditing: true,
    allowHeaderFiltering: false,
    allowSorting: false,
    allowFiltering: true
  },
  {
    dataField: 'iSsectorIDIS2025',
    name: 'iSsectorIDIS2025',
    caption: 'event.detail.eventSector',
    calculateCellValue: 'calcIsSector2025',
    dataType: 'number',
    width: 150,
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowSorting: false,
    allowFiltering: false,
    lookup: {
      dataSource: 'eventStartupSectors',
      displayExpr: 'sector',
      valueExpr: 'field_001',
      allowClearing: true
    }
  },
  {
    dataField: 'yearsOfIndustryExperienceIS2025',
    name: 'yearsOfIndustryExperienceIS2025',
    caption: 'event.detail.yearsOfIndustry',
    calculateCellValue: 'calcIsYearsOfIndustry2025',
    dataType: 'number',
    width: 150,
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowSorting: false,
    allowFiltering: false,
    lookup: {
      dataSource: 'eventIndustryExperiences',
      displayExpr: 'yearsofindustryexperience',
      valueExpr: 'field_001',
      allowClearing: true
    }
  },
  {
    dataField: 'cRMAddress.vLABIncorporatedStatus.incorporatedStatus',
    name: 'cRMAddress.vLABIncorporatedStatus.incorporatedStatus',
    caption: 'event.detail.incorporatedStatus',
    width: 180,
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowSorting: true
  },
  {
    dataField: 'cRMAddress.profiles[0].vleadersTechnologie',
    name: 'cRMAddress.profiles[0].vleadersTechnologie',
    caption: 'event.detail.vleadersTechnologie',
    dataType: 'string',
    width: 300,
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false,
    isProfile: true
  },
  {
    dataField: 'cRMAddress.profiles[0].vleadersFinancials',
    name: 'cRMAddress.profiles[0].vleadersFinancials',
    caption: 'event.detail.vleadersFinancials',
    dataType: 'string',
    width: 300,
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false,
    isProfile: true
  },
  {
    dataField: 'eVENTQuestionnairejoinedModulesJOrderIS2025s.eVENTEventStartupISModulesInnosuisse2025.joinedInnosuissemodules',
    name: 'eVENTQuestionnairejoinedModulesJOrderIS2025s.eVENTEventStartupISModulesInnosuisse2025.joinedInnosuissemodules',
    caption: 'event.detail.joinedInnosuissemodules',
    calculateCellValue: 'calcJoinedSuisseModules',
    width: 300,
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    dataField: 'eVENTQuestionnaireJOINEventGlobals.iSWhereAttendPreviousModulesIS2025',
    name: 'eVENTQuestionnaireJOINEventGlobals.iSWhereAttendPreviousModulesIS2025',
    caption: 'event.detail.iSWhereAttendPreviousModulesIS2025',
    calculateCellValue: 'getFirstElementIsWhereAttendPreviousModulesIS2025',
    allowEditing: false,
    width: 180,
    visible: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    dataField: 'eVENTQuestionnaireoprogramsJOrderIS2025s.eVENTQuestionnaireOtherISprogramsIS2025.innosuisseprograms',
    name: 'eVENTQuestionnaireoprogramsJOrderIS2025s.eVENTQuestionnaireOtherISprogramsIS2025.innosuisseprograms',
    caption: 'event.detail.innosuisseprograms',
    calculateCellValue: 'calcInnosuisseprograms',
    width: 250,
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    dataField: 'eVENTQuestionnaireJOINEventGlobals.iSemploymentStatusIS2025',
    name: 'eVENTQuestionnaireJOINEventGlobals.iSemploymentStatusIS2025',
    caption: 'event.detail.iSemploymentStatusIS2025',
    calculateCellValue: 'getFirstElementIsemploymentStatusIS2025',
    allowEditing: false,
    width: 180,
    visible: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false,
    lookup: {
      dataSource: 'eventEmploymentStatus',
      displayExpr: 'employmentstatus',
      valueExpr: 'field_001',
      allowClearing: true
    }
  },
  {
    dataField: 'eVENTQuestionnairedinterestJOrderIS2025s.eVENTQuestionnairedescribesinterestIS2025.describesyourcurrentinterest',
    name: 'eVENTQuestionnairedinterestJOrderIS2025s.eVENTQuestionnairedescribesinterestIS2025.describesyourcurrentinterest',
    caption: 'event.detail.describesyourcurrentinterest',
    calculateCellValue: 'calcDescribesyourcurrentinterest',
    width: 300,
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    dataField: 'eVENTQuestionnaireUNDevGoalsJOrderIS2025s.eVENTQuestionnaireUNDevGoalsIS2025.uNSustainableDevelopmentGoals',
    name: 'eVENTQuestionnaireUNDevGoalsJOrderIS2025s.eVENTQuestionnaireUNDevGoalsIS2025.uNSustainableDevelopmentGoals',
    caption: 'event.detail.uNSustainableDevelopmentGoals',
    calculateCellValue: 'calcUnSustainableDevelopmentGoals',
    width: 300,
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    dataField: 'iScurrentRelationshipWithTheUniIS2025',
    name: 'iScurrentRelationshipWithTheUniIS2025',
    caption: 'event.detail.currentRelationshipWithUni',
    calculateCellValue: 'calcIsCurrentRelationship2025',
    dataType: 'number',
    width: 150,
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowSorting: false,
    allowFiltering: false,
    lookup: {
      dataSource: 'eventRelationshipUnis',
      displayExpr: 'currentrelationshipwiththeUniversity',
      valueExpr: 'field_001',
      allowClearing: true
    }
  },
  {
    dataField: 'cRMAddress.cRMNationalitt.nationalitt',
    name: 'cRMAddress.cRMNationalitt.nationalitt',
    caption: 'event.detail.primaryNationality',
    width: 200,
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: true,
    allowSorting: true
  },
  {
    dataField: 'salutationIdGender',
    name: 'cRMAddress.salutationGenderId',
    caption: 'event.detail.gender',
    width: 150,
    visible: false,
    dataType: 'number',
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false,
    withoutQueryField: true,
    calculateCellValue: 'getSalutationId',
    lookup: {
      dataSource: 'salutationTypes',
      displayExpr: 'iSGender',
      valueExpr: 'ansprechzeile_id',
      allowClearing: false
    }
  },
  {
    dataField: 'iSDisclaimerAccepttobecontacted',
    caption: 'event.detail.iSDisclaimerAccepttobecontacted',
    name: 'iSDisclaimerAccepttobecontacted',
    calculateCellValue: 'calcIsDisclaimer',
    dataType: 'string',
    width: 160,
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowSorting: true,
    allowFiltering: true
  },
  {
    internVisible: true,
    internCode: 'joinRolles',
    caption: 'intern Roles',
    dataField: 'cRMAddress.cRMAdresseJOINRolles.rolle_id',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    internVisible: false,
    internCode: 'unterstuetzung',
    caption: 'intern Support',
    dataField: 'cRMAddress.profiles[0].pROFILUntersttzungszuweisungs.untersttzungId',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    internVisible: false,
    internCode: 'investmenStage',
    caption: 'intern invesetmenstage',
    dataField: 'cRMAddress.profiles[0].cRMFundingProfileV2s.investmentsStage',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    internVisible: false,
    internCode: 'fundingStatusId',
    caption: 'intern statusId',
    dataField: 'cRMAddress.profiles[0].cRMFundingProfileV2s.statusId',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    internVisible: false,
    internCode: 'fundingMoneyInCHF',
    caption: 'intern moneyInCHF',
    dataField: 'cRMAddress.profiles[0].cRMFundingProfileV2s.moneyinCHF',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    internVisible: false,
    internCode: 'fundingClosingDate',
    caption: 'intern funding Closingdate',
    dataField: 'cRMAddress.profiles[0].cRMFundingProfileV2s.closingdate',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    internVisible: false,
    internCode: 'evaluationCasequality',
    caption: 'intern evaluation casequality',
    dataField: 'vLABEvaluations.sEMINARCasequality.casequality',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    internVisible: true,
    internCode: 'profileType',
    caption: 'intern profile type',
    dataField: 'cRMAddress.profiles[0].profiltypId',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    internVisible: true,
    internCode: 'profileAdressId',
    caption: 'intern profile crmAdressId',
    dataField: 'cRMAddress.profiles[0].cRM_Adress_id',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    internVisible: true,
    internCode: 'addressSalutationId',
    caption: 'intern crmAddress salutationId',
    dataField: 'cRMAddress.salutationId',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    internVisible: false,
    internCode: 'addressBirthday',
    caption: 'intern crmAddress birthday',
    dataField: 'cRMAddress.birthday',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    internVisible: false,
    internCode: 'joinedInnosuissemodules',
    dataField: 'eVENTQuestionnairejoinedModulesJOrderIS2025s.eVENTEventStartupISModulesInnosuisse2025.sort',
    caption: 'intern joinedInnosuissemodules',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    internVisible: false,
    internCode: 'innosuisseprograms',
    dataField: 'eVENTQuestionnaireoprogramsJOrderIS2025s.eVENTQuestionnaireOtherISprogramsIS2025.sortierung',
    caption: 'intern joinedInnosuissemodules',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    internVisible: false,
    internCode: 'describesyourcurrentinterest',
    dataField: 'eVENTQuestionnairedinterestJOrderIS2025s.eVENTQuestionnairedescribesinterestIS2025.sort',
    caption: 'intern describesyourcurrentinterest',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    internVisible: false,
    internCode: 'uNSustainableDevelopmentGoals',
    dataField: 'eVENTQuestionnaireUNDevGoalsJOrderIS2025s.eVENTQuestionnaireUNDevGoalsIS2025.sort',
    caption: 'intern uNSustainableDevelopmentGoals',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    internVisible: false,
    internCode: 'eventEventlisttitleEN',
    dataField: 'crmEvent.eventlisttitleEN',
    caption: 'intern eventlisttitleEN',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    internVisible: false,
    internCode: 'eventSortierdatum',
    dataField: 'crmEvent.sortierdatum',
    caption: 'intern sortierdatum',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    internVisible: false,
    internCode: 'eventLocationname',
    dataField: 'crmEvent.gRUNDWERTELocationInnosuiss.locationname',
    caption: 'intern locationname',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    internVisible: false,
    internCode: 'isCoursesIsSector2025',
    dataField: 'eVENTQuestionnaireJOINEventGlobals.iSsectorIS2025',
    caption: 'intern IS sector 2025',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    internVisible: false,
    internCode: 'isCoursesIsStartupStage2025',
    dataField: 'eVENTQuestionnaireJOINEventGlobals.iSstartupStageIS2025',
    caption: 'intern IS startup stage 2025',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    internVisible: false,
    internCode: 'isCoursesYearsOfIndustryExperience2025',
    dataField: 'eVENTQuestionnaireJOINEventGlobals.iSyearsOfIndustryExperienceIS2025',
    caption: 'intern IS years of industry experience 2025',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  },
  {
    internVisible: false,
    internCode: 'isCoursesCurrentRelationshipWithTheUni2025',
    dataField: 'eVENTQuestionnaireJOINEventGlobals.iScurrentRelationshipWithTheUniIS2025',
    caption: 'intern current relationship with the uni 2025',
    visible: false,
    allowEditing: false,
    allowHeaderFiltering: false,
    allowFiltering: false,
    allowSorting: false
  }
]
